var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatcallicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_3624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8558 13.1439C9.68578 11.9739 8.80378 10.6639 8.21778 9.33487C8.09378 9.05387 8.16678 8.72487 8.38378 8.50787L9.20278 7.68987C9.87378 7.01887 9.87378 6.06987 9.28778 5.48387L8.11378 4.30987C7.33278 3.52887 6.06678 3.52887 5.28578 4.30987L4.63378 4.96187C3.89278 5.70287 3.58378 6.77187 3.78378 7.83187C4.27778 10.4449 5.79578 13.3059 8.24478 15.7549C10.6938 18.2039 13.5548 19.7219 16.1678 20.2159C17.2278 20.4159 18.2968 20.1069 19.0378 19.3659L19.6888 18.7149C20.4698 17.9339 20.4698 16.6679 19.6888 15.8869L18.5158 14.7139C17.9298 14.1279 16.9798 14.1279 16.3948 14.7139L15.4918 15.6179C15.2748 15.8349 14.9458 15.9079 14.6648 15.7839C13.3358 15.1969 12.0258 14.3139 10.8558 13.1439V13.1439Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_3624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatcallicon);
export default __webpack_public_path__ + "static/media/chatcallicon.337cab336c1282e1e1ddadd47635ed12.svg";
export { ForwardRef as ReactComponent };